import { render, staticRenderFns } from "./NavBarMenuItem.vue?vue&type=template&id=13e7b53e&scoped=true"
import script from "./NavBarMenuItem.vue?vue&type=script&lang=js"
export * from "./NavBarMenuItem.vue?vue&type=script&lang=js"
import style0 from "./NavBarMenuItem.vue?vue&type=style&index=0&id=13e7b53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e7b53e",
  null
  
)

export default component.exports